function useDataLayer() {
    // @ts-ignore
    return window.dataLayer ?? [];
}

export default useDataLayer;